import { createReducer } from '@reduxjs/toolkit'
import { Granularity } from 'interfaces/api/granularities.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllGranularities } from './actions'

interface GranularitiesState {
  list: {
    loading: boolean
    items: Granularity[]
  }
}

const initialState: GranularitiesState = {
  list: {
    loading: false,
    items: [],
  },
}

export const granularitiesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllGranularities.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllGranularities.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllGranularities.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })
})
